import FirstBlockWrapper from './FirstBlockWrapper'

export default FirstBlockWrapper
